import { useEffect } from 'react'
import { ICurrentUser } from '@query'
import { setDayJsLocale } from '@localisation/time.ts'
import { useTranslation } from 'react-i18next'
import Cookies from 'js-cookie'

export enum ValidLocale {
  FI = 'fi',
  SV = 'sv',
  EN = 'en',
  DE = 'de'
}

const DEFAULT_LOCALE = ValidLocale.FI

const getBrowserLanguage = (): ValidLocale => {
  const lang = navigator?.language?.split('-')[0]?.toUpperCase() as keyof typeof ValidLocale
  return ValidLocale[lang] || DEFAULT_LOCALE
}

const getAppLanguage = (): ValidLocale =>
  Cookies.get(import.meta.env.VITE_LANGUAGE_COOKIE_NAME) as ValidLocale

export const getCurrentLocale = (): ValidLocale => getAppLanguage() ?? getBrowserLanguage()

export const useCurrentUserLanguage = (user?: ICurrentUser): void => {
  const { i18n } = useTranslation()

  const changeLocale = async (newLocale: ValidLocale): Promise<void> => {
    /* 
    CASE: App is loaded for the first time.
    1. The language cookie is not yet set 
    thus using the browser language.
    2. After user data is fetched, 
    the app language is changed to user's preferred language
    in the useEffect.
    3. The language is set correctly in the LanguagePicker but
    the translations are still in the old selection.
    
    FIX: Call the reloadResources method to reload the translations.
    Not sure why this fixes the issue... x_x
    */

    await i18n.reloadResources([newLocale], i18n.options?.ns)
    await i18n.changeLanguage(newLocale)
    setDayJsLocale(newLocale)
  }

  useEffect(() => {
    user?.language && changeLocale(user.language)
  }, [user?.language])
}
